export default __webpack_public_path__ + "static/media/idd5.781bec55.png";